<div class="dialog">
  <flame-empty-state [icon]="_data.icon">
    <flame-empty-state-content>
      <h2>{{ _data?.title}}</h2>
      <div class="fl-empty-text">
        {{ _data.message }}
      </div>
      <button flameButton
        color="primary"
        (click)="closeDialog()"
        class="btn"
      > {{ call ? 'Llamar a SuperLínea' : _data.buttonLabel }} </button>
    </flame-empty-state-content>
  </flame-empty-state>

  <div class="dialog__error">
    {{ _data.code}}
  </div>
</div>
